import { delay } from 'redux-saga'
import {
  call,
  cancel,
  fork,
  put,
  select,
  take,
  takeEvery
} from 'redux-saga/effects'

import {
  incrementTimer,
  stopTimer
} from '../duck/operations'

import types from '../duck/types'

export function* timer() {
  while (yield take(types.START_TIMER)) {
    const timerTask = yield fork(watchIncrementTimer)
    yield call(incrementTimerAsync)

    // Both actions should stop the timer. The difference is in the state set in the reducers
    yield take([types.RESET_TIMER, types.STOP_TIMER])

    yield cancel(timerTask)
  }
}

function* watchIncrementTimer() {
  yield takeEvery(types.INCREMENT_TIMER, incrementTimerAsync)
}

function* incrementTimerAsync() {
  yield delay(1000)
  const state = yield select()
  if (state.position < state.duration) {
    yield put(incrementTimer())
  } else {
    yield put(stopTimer())
  }
}



// WEBPACK FOOTER //
// ./src/sagas/timerSaga.js